import { useState, useEffect } from "react";
import { SCORING, DIMENSIONS } from "../hooks/useQuestions";

function generateRecommendations(obj) {
  const { dimension, score } = obj;
  if (dimension === "Customer") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Implement solutions which gather and provide Digital Customer Insights.",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Invest in and utilise Data and Analytical tools to improve business decisions, prioritisation and Customer experiences.",
        to: "Maturing",
      },
    };
  }

  if (dimension === "Sustainable Operating Model") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Leverage the Ecosystem to gain access to resources such as technology and people to improve the organisation’s ability to innovate and grow.",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Develop a talent strategy and focus on the digital skills and roles needed to achieve mid to long term goals in order to support the organisation’s digital strategy.",
        to: "Maturing",
      },
    };
  }

  if (dimension === "Capabilities") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Implement an “Ideas container” portal to enable employees to drop in new ideas and foster brainstorming sessions Incentives can be provided to encourage the innovation mind set.",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Educate Leadership on the benefits of digital workplace initiatives and appoint a suitable candidate to become the Digital Workplace Leader.",
        to: "Maturing",
      },
    };
  }

  if (dimension === "Culture") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Use a shared platform to communicate company plans, strategies and challenges ahead of time, to ensure consistent and continuous transparency across the organisation.",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Encourage continuous innovation i.e. Run Hackathons, Datathons or provide grants/rewards for research. Incorporate these initiatives into the organisation’s culture.",
        to: "Maturing",
      },
    };
  }

  if (dimension === "Technology") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Focus on business problems aligned to business strategy, align assessment criteria and technology requirements to business goals.",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Develop an API strategy including establishing clear business objectives, outlining the business purpose and build an API strategy into your corporate plan.",
        to: "Maturing",
      },
    };
  }

  if (dimension === "Data") {
    if (score <= 4) {
      return {
        dimension,
        result: {
          from: "Nascent",
          recommendation:
            "Ensure decision making is based on data centric evidence and insights gained from available data are shared for the benefit of the teams who need them",
          to: "Developing",
        },
      };
    }
    return {
      dimension,
      result: {
        from: "Developing",
        recommendation:
          "Consider potential value from R&D including allowing for testing of new ideas, and support for data driven decision making",
        to: "Maturing",
      },
    };
  }

  return null;
}

/** Hook to compute the scores */
function useScore(questions) {
  const [scores, setScores] = useState([
    {
      ...DIMENSIONS.SUSTAINABLE_OPERATING_MODEL,
      score: 0,
    },
    {
      ...DIMENSIONS.CAPABILITIES,
      score: 0,
    },
    {
      ...DIMENSIONS.TECHNOLOGY,
      score: 0,
    },
    {
      ...DIMENSIONS.CULTURE,
      score: 0,
    },
    {
      ...DIMENSIONS.DATA,
      score: 0,
    },
    {
      ...DIMENSIONS.CUSTOMER,
      score: 0,
    },
  ]);
  const [recommendations, setRecommendations] = useState([{}]);

  useEffect(() => {
    const computedScores = questions.reduce((acc, curr) => {
      const indexOf = acc.findIndex((d) => d.label === curr.dimension);
      const { score } = SCORING.filter((s) => s.value === curr.answer)[0];
      acc[indexOf].score += score;
      return acc;
    }, scores);

    setScores(computedScores);
  }, [questions, scores]);

  useEffect(() => {
    const computedRecommendations = scores
      .map((d) =>
        generateRecommendations({ dimension: d.label, score: d.score })
      )
      .filter((r) => r !== null);

    setRecommendations(computedRecommendations);
  }, [scores]);

  console.log(recommendations);

  return [scores, recommendations];
}

export default useScore;
